export default __webpack_public_path__ + "static/media/img_right.253ab2ba.svg";